import React from 'react';

const rightArrowIcon = React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", fill: "none" },
    React.createElement("path", { d: "M4 12H20M20 12L14 6M20 12L14 18", stroke: "#121212", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }));

export { rightArrowIcon };
//# sourceMappingURL=right_arrow_icon.js.map
